<template>
<div class="b-container">
  <div id="newproject">
     <div class="md-container md-gutter">
    <v-dialog v-model="showJobs">
      <v-dialog-title>
      </v-dialog-title>
      <v-tabs md-dynamic-height>
        <v-tab md-label="Jobs">
          <div>
       
    <v-table v-model="searched" md-sort="name" md-sort-order="asc" md-card md-fixed-header @md-selected="onSelect">
      <v-table-toolbar>

        <v-text-field md-clearable class="md-toolbar-section-end">
          <v-input placeholder="Search by name..." v-model="search" @input="searchOnTable" />
        </v-text-field>
      </v-table-toolbar>

        <!-- job list -->
        <!-- /* eslint-disable */ -->

        <v-table-row slot="md-table-row" slot-scope="{ item }" :class="getClass(item)" md-selectable="single">
        <!-- <v-table-cell md-label="Photo" md-sort-by="imageUrl">{{ item.imageUrl }}</v-table-cell> -->
        <v-table-cell md-label="Position" md-sort-by="title">{{ item.title }}</v-table-cell>
        <v-table-cell md-label="Déscription" md-sort-by="id">{{ item.description }}</v-table-cell>
        <v-table-cell md-label="Nom du project" md-sort-by="projectName">{{ item.projectName }}</v-table-cell>
        
      </v-table-row>
      
    </v-table>
  </div>
        </v-tab>

        <v-tab md-label="Backers">
          <div>
       
    <v-table v-model="searched" md-sort="name" md-sort-order="asc" md-card md-fixed-header @md-selected="onSelect">
      <v-table-toolbar>

        <v-text-field md-clearable class="md-toolbar-section-end">
          <v-input placeholder="Search by name..." v-model="search" @input="searchOnTable" />
        </v-text-field>
      </v-table-toolbar>

        <!-- backers -->

      <v-table-row slot="md-table-row" slot-scope="{ item }" :class="getClass(item)" md-selectable="single">
        <!-- <v-table-cell md-label="Photo" md-sort-by="imageUrl">{{ item.imageUrl }}</v-table-cell> -->
        <v-table-cell md-label="Nom et Prénom" md-sort-by="lastName">{{ item.firstName }} {{ item.lastName }}</v-table-cell>
        <v-table-cell md-label="Phone" md-sort-by="description">{{ item.phone }}</v-table-cell>
        <v-table-cell md-label="Montant du donation" md-sort-by="projectName">{{ item.donationAmount }}</v-table-cell>
      </v-table-row>
    </v-table>
  </div>
        </v-tab>
      </v-tabs>

      <v-dialog-actions>
        <v-btn class="md-primary" @click="showJobs = false">Close</v-btn>
        <!-- <v-btn class="md-primary" @click="showJobs = false">Save</v-btn> -->
      </v-dialog-actions>
    </v-dialog>
  </div> 
     
     
      <v-snackbar v-model="infoUpdatedSnack">
      <span>le projet {{form.title}}: a été modifié</span>
        <v-btn class="md-primary" @click="infoUpdatedSnack = false">Ok</v-btn>
      </v-snackbar>
        <!-- project form -->

     <form novalidate class="md-layout" @submit.prevent="updateProject">
      <v-card class="md-layout-item">
        <v-card-content>
          <v-toolbar :md-elevation="1">
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
        <span class="md-title">Nom du project: {{form.title}}</span>
              </div>
              <div class="md-layout-item">
        <span class="md-title">Date crée: {{ this.form.createdDate | formatDate }}</span>
              </div>
            </div>
      </v-toolbar>
      <br>

          <div class="md-layout md-gutter">
            <div class="md-layout-item" style="display:none">
                <v-text-field
                  label="Titre du project"
                  type="text"
                  autocomplete="given-name"
                  v-model="project_id"
                  required>
                </v-text-field>
            </div>
            <div class="md-layout-item">
                <v-text-field
                label="Titre du project"
                v-model="form.title"
                autocomplete="given-name"
                required>
              </v-text-field>
            </div>
           <div class="md-layout-item">
        <b-input-group prepend><label>Date de d'achèvement du project</label></b-input-group>
        <b-form-input class="active" type="date" typeable="true" v-model="form.endingDate"> </b-form-input>
        </div>
          </div>
           <div class="md-layout md-gutter">
                <div class="md-layout-item">
          <h9>Déscription du project</h9>
          <v-text-field>
          <v-textarea
          placeholder="Détailler"
          ref="projectDescription"
          v-model="form.description"
          :min-height="30"
          :max-height="350"
          required
        ></v-textarea>
          </v-text-field>
          
        </div>
          </div>
          <div class="md-layout md-gutter">
              <div class="md-layout-item">
            <v-text-field
          label="Nombre d'heures de bénevolat necéssaires"
          type="number"
          min="0"
          v-model.number="form.volunteerHoursGoalAmt"
          required
          suffix="heures">
          </v-text-field>
              </div>
          <div class="md-layout-item">
            <br><br>
             <vue-slider ref="vSlider" v-bind="dOptions" :max="form.volunteerHoursGoalAmt" :value="[form.volunteerHoursCurrentAmt,form.volunteerHoursGoalAmt]"></vue-slider>
             <label for="volunteeringHours">Nombre d'heures de bénevolat accumulées: {{this.form.volunteerHoursCurrentAmt}}</label>
             </div>
          </div>
             <div class="md-layout md-gutter">
             <div class="md-layout-item">
           <v-text-field
            prefix="FC"
            label="Dons monétaires necéssaires"
            type="number"
            min="0"
            v-model.number="form.donationGoalAmt"
            required>
          </v-text-field>
             </div>
             <div class="md-layout-item">
               <br><br>
             <vue-slider ref="dSlider" v-bind="dOptions" :max="form.donationGoalAmt" :value="[form.donationCurrentAmt,form.donationGoalAmt]"></vue-slider>
             <label for="donationGoalAmt">Dons accumulés: {{this.form.donationCurrentAmt}}</label>
             </div>
             </div>
             <div class="md-layout md-gutter">
             <div class="md-layout-item">
             <v-text-field
              label="Nombre d'employés necéssaires?"
            type="number"
            min="0"
            v-model.number="form.workerGoalQty"
            required>
          </v-text-field>
             </div>
             <div class="md-layout-item">
                <br><br>             
             <vue-slider v-bind="dOptions" :value="[form.workerCurrentQty,form.workerGoalQty]" :max="form.workerGoalQty"></vue-slider>
             <label for="volunteeringHours">Nombre d'employés engagés: {{this.form.workerCurrentQty}}</label>
             </div>
             </div>
             
        <div class="md-layout md-gutter">
         <div class="md-layout-item">
      <span class="md-layout-item inline"><medium>Postes et Backers</medium></span>
      <div class="md-layout md-gutter">
          <div class="md-layout-item">
      <v-btn class="md-fab" @click="fetchJobList">
        <v-icon>menu</v-icon>
        <v-tooltip md-direction="right">Postes</v-tooltip>
      </v-btn>
          </div>
          <div class="md-layout-item">
      <v-btn class="md-fab md-primary" @click="fetchJobList">
        <v-icon>menu</v-icon>
        <v-tooltip md-direction="right">Backers</v-tooltip>
      </v-btn>
            </div>
             </div>
         </div>
       
            <div class="md-layout-item">
              <label for="timeOnCurrentJob">Statut du project</label>
          <b-input-group>
        <select class="custom-select" id="status" v-model="form.status">
          <option value="Nouveau">Nouveau</option>
          <option value="En cours">En cours</option>
          <option value="Terminé">Terminé</option>
        </select>
          </b-input-group>
                
            </div>
            <div class="md-layout-item">
          <v-text-field
          label="Type de project"
          type="text"
          v-model="form.type"
          required>
          </v-text-field>
            </div>
              </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
            <v-text-field
            label="Telephone"
            type="tel"
            autocomplete="phone"
            v-model="form.phone"
            hint="1234567890"
            required>
            </v-text-field>
              </div>
               <div class="md-layout-item">
            <v-text-field
            label="Dernière mise à jour par"
            type="text"
            autocomplete="name"
            v-model="form.updatedBy">
            </v-text-field>
               </div>
               <div class="md-layout-item">
           <v-text-field
            label="Date du dernière mise à jour"
            disabled
            type="text"
            autocomplete="name"
            v-model="form.updatedDate">
          </v-text-field>
              </div>
            </div>
                <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <v-autocomplete v-model="form.city" name="city" id="city" :md-options="areas" md-dense required>
                 <label>Commune</label>
              </v-autocomplete>
          </div>
          <div class="md-layout-item">           
            <v-autocomplete v-model="form.postalCode" :md-options="zones" md-dense required>
                 <label>Quartier</label>
              </v-autocomplete>
          </div>
           <div class="md-layout-item">
            <v-text-field
            label="Avenue et numero"
            type="text"
            autocomplete="address"
            v-model="form.address"
            required>
          </v-text-field>
              </div>
            </div>
            <b-row>
              <b-col>
                 <b-row align-h="start">
        <v-card-actions>
          <v-btn @click="deleteProject" class="md-accent md-raised">Suprimer</v-btn>
        </v-card-actions>
          </b-row>
              </b-col>
            <b-col>
            <b-row align-h="end">
              <v-card-actions style="display:inline">
          <router-link :to="{ name: 'projects', params: { job_id: this.project_id }}"><v-btn class="md-primary md-raised">Retour</v-btn></router-link>
          
        </v-card-actions>
        <v-card-actions style="display:inline">
          <v-btn @click="createJob" class="md-primary md-raised">Ajouter un job</v-btn>
          
        </v-card-actions>
        <v-card-actions style="display:inline">
          <v-btn type="submit" class="md-primary md-raised">Enregistrer</v-btn>
        </v-card-actions>
        </b-row>
            </b-col>
            </b-row>
        </v-card-content>
      </v-card>
    </form>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
import vueSlider from 'vue-slider-component';
import { quartiers } from '@/api/quartiers';
import { communes } from '@/api/communes';
const toLower = text => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.title).includes(toLower(term)));
  }

  return items;
};
export default {
  name: 'newproject',
  components: {
    vueSlider
  },
  created () {
    this.project_id = this.$route.params.project_id;
    this.createdBy = firebase.auth().currentUser.displayName;
  },
  data () {
    return {
      dOptions: {
        value: [0, 500],
        min: 0,
        max: 500,
        show: false,
        tooltip: 'always',
        formatter: '{value}',
        tooltipDir: ['top', 'top'],
        height: 8,
        show: true,
        dotSize: 20,
        overlapFormatter: '¥{value1} ~ ¥{value2}',
        bgStyle: {
          backgroundColor: '#8039CB'
        },
        processStyle: {
          backgroundColor: '#fff',
          boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
        },
        tooltipStyle: {
          backgroundColor: '#8039CB',
          borderColor: '#666'
        }
      },
      infoUpdatedSnack: false,
      selected: {},
      search: null,
      searched: [],
      jobs: [],
      backers: [],
      project_id: null,
      zones: quartiers,
      areas: communes,
      showBackers: false,
      showJobs: false,
      job_id: null,
      form: {
        createdDate: Date,
        title: null,
        description: null,
        endingDate: null,
        volunteerHoursGoalAmt: 100,
        volunteerHoursCurrentAmt: 0,
        donationGoalAmt: 100,
        donationCurrentAmt: 0,
        workerCurrentQty: 0,
        workerGoalQty: 100,
        backers: null,
        createdBy: null,
        type: null,
        status: 'Nouveau',
        address: null,
        city: null,
        postalCode: null,
        updatedBy: firebase.auth().currentUser.displayName,
        updatedDate: null
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    db
      .collection('Projects')
      .doc(to.params.project_id)
      .get()
      .then(function(doc) {
        next(vm => {
          (vm.form.createdDate = doc.data().createdDate),
            (vm.form.title = doc.data().title),
            (vm.form.description = doc.data().description),
            (vm.form.volunteerHoursGoalAmt = doc.data().volunteerHoursGoalAmt),
            (vm.form.volunteerHoursCurrentAmt = doc.data().volunteerHoursCurrentAmt),
            (vm.form.donationGoalAmt = doc.data().donationGoalAmt),
            (vm.form.donationCurrentAmt = doc.data().donationCurrentAmt),
            (vm.form.workerCurrentQty = doc.data().workerCurrentQty),
            (vm.form.workerGoalQty = doc.data().workerGoalQty),
            (vm.form.endingDate = doc.data().endingDate),
            (vm.form.status = doc.data().status),
            (vm.form.backers = doc.data().backers),
            (vm.form.createdBy = doc.data().createdBy),
            (vm.form.address = doc.data().address),
            (vm.form.city = doc.data().city),
            (vm.form.postalCode = doc.data().postalCode),
            (vm.form.updatedBy = doc.data().updatedBy),
            (vm.form.type = doc.data().type),
            (vm.form.updatedDate = doc.data().updatedDate);
        });
      });
  },
  watch: {
    $route: 'fetchData'
  },
  methods: {
    searchOnTable () {
      this.searched = searchByName(this.jobs, this.search);
    },
    getClass: ({ type }) => ({
      // 'md-primary':
    }),
    onSelect(item) {
      this.selected = item;
      this.$router.push({
        name: 'edit-job',
        params: {
          job_id: item.job_id
        }
      });
    },
    fetchJobList () {
      db
        .collection('Jobs')
        .where('projectId', '==', this.project_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              job_id: doc.id,
              title: doc.data().title,
              description: doc.data().description,
              projectName: doc.data().projectName,
              projectId: doc.data().projectId
            };
            this.jobs.push(data);
            this.searched = this.jobs;
            this.showJobs = true;
          });
        });
    },
    fetchBackers () {
      db
        .collection('Users')
        .doc('Donations')
        .where('projectId', '==', this.project_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              job_id: doc.id,
              title: doc.data().title,
              description: doc.data().description,
              projectName: doc.data().projectName
            };
            this.jobs.push(data);
            this.searched = this.jobs;
            this.showJobs = true;
          });
        });
    },

    fetchData () {
      db
        .collection('Projects')
        .doc(this.project_id)
        .get()
        .then(function(doc) {
          (this.form.createdDate = doc.data().createdDate),
            (this.form.title = doc.data().title),
            (this.form.description = doc.data().description),
            (this.form.endingDate = doc.data().endingDate),
            (this.form.volunteerHoursGoalAmt = doc.data().volunteerHoursGoalAmt),
            (this.form.volunteerHoursCurrentlAmt = doc.data().volunteerHoursCurrentAmt),
            (this.form.donationGoalAmt = doc.data().donationGoalAmt),
            (this.form.donationCurrentAmt = doc.data().donationCurrentAmt),
            (this.form.workerCurrentQty = doc.data().workerCurrentQty),
            (this.form.workerGoalQty = doc.data().workerGoalQty),
            (this.form.status = doc.data().status),
            (this.form.backers = doc.data().backaers),
            (this.form.address = doc.data().address),
            (this.form.city = doc.data().city),
            (this.form.postalCode = doc.data().postalCode),
            (this.form.updatedBy = doc.data().updatedBy),
            (this.form.type = doc.data().type),
            (this.form.updatedDate = doc.data().updatedDate);
        });
    },
    updateProject () {
      var that = this;
      this.form.updatedDate = new Date();
      db
        .collection('Projects')
        .doc(this.project_id)
        .update({
          title: this.form.title,
          description: this.form.description,
          volunteerHoursGoalAmt: this.form.volunteerHoursGoalAmt,
          donationGoalAmt: this.form.donationGoalAmt,
          workerGoalQty: this.form.workerGoalQty,
          endingDate: this.form.endingDate,
          status: this.form.status,
          address: this.form.address,
          city: this.form.city,
          type: this.form.type,
          postalCode: this.form.postalCode,
          updatedBy: this.form.updatedBy,
          updatedDate: this.form.updatedDate
        })
        .then(() => {
          that.infoUpdatedSnack = true;
        })
        .catch(error => {
          console.error('Error adding member: ', error);
        });
    },
    createJob () {
      var memberRef = db.collection('Jobs').doc();
      var refKey = memberRef.id;
      this.job_id = refKey;
      memberRef
        .set({
          createdBy: this.createdBy,
          updatedBy: this.createdBy,
          projectId: this.project_id,
          projectName: this.form.title,
          createdDate: new Date(),
          address: this.form.address,
          city: this.form.city,
          postalCode: this.form.postalCode
        })
        .then(() => {
          this.$router.push({
            name: 'new-job',
            params: {
              project_id: this.project_id,
              createdBy: this.createdBy,
              job_id: this.job_id,
              createdDate: new Date()
            }
          });
        })
        .catch(error => {
          console.error('Error adding member: ', error);
        });
    },
    deleteProject () {
      var that = this;
      if (confirm('Are you sure?')) {
        db
          .collection('Projects')
          .doc(this.project_id)
          .delete()
          .then(function() {
            alert(`Ce projet a été suprimé`);
            that.$router.push('projects');
          });
      }
    },
    updateVolunteerSlider () {
      // $ref.vSlider.max = this.form.volunteeringHours
    }
  }
};
</script>
<style lang='scss' scoped>
.md-dialog {
  max-width: 768px;
}
body {
  padding-top: 70px;
}
.md-drawer {
  padding-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/form/NewProject.vue